export default __webpack_public_path__ + "static/media/Awaydays-1.aca253a2.png";